<template>
    <div class="menu-field">
        <div class="menu-inner-field">
            <EonOutlinedIconButton
                icon="pi pi-th-large"
                class="mobile-bottom-menu-button"
                :class="{ active: isActive('/public/planned') }"
                @click="goTo('/public/planned')"
                label="Wyłączenia"
                retain-focus-on-click
            />
            <EonOutlinedIconButton
                icon="pi pi-compass"
                class="mobile-bottom-menu-button"
                :class="{ active: isActive('/public') }"
                @click="goTo('/public')"
                label="Mapa"
                retain-focus-on-click
                to="/public"
            />
            <EonOutlinedIconButton
                icon="pi pi-user"
                class="mobile-bottom-menu-button"
                :class="{ active: isActive(['/public/user/settings', '/public/user/address', '/public/user/reports']) }"
                @click="isUserLoggedIn ? toggleMenu($event) : toggleLoginSidebar()"
                label="Konto"
                retain-focus-on-click
            />
            <PrimeMenu
                :model="userItems"
                style="border: none;"
                popup
                ref="menu"
                @click="handleItemClick"
            >
            </PrimeMenu>
        </div>
    </div>
</template>
<script>
    import Menu from "primevue/menu";
    import TabMenu from "primevue/tabmenu";
    import {SystemRole} from "@/utils/SystemRole";
    import EonOutlinedIconButton from "@/components/form/EonOutlinedIconButton";

    export default {
        name: "EonTabMenuMobile",
        components: {
            // EonIconButton,
            EonOutlinedIconButton,
            TabMenu,
            PrimeMenu: Menu,
        },

        data() {
            return {
                showSidebar: false,
                show: false,
                activeIndex: null,
            };
        },

        props: {
            menuItems: {
                type: Array,
            },
            isUserLoggedIn: {
                type: Boolean,
                default: false,
            },
            onLogout: {
                type: Function,
                required: false,
            },
        },

        methods: {
            isActive(paths) {
                if (Array.isArray(paths)) {
                    return paths.includes(this.$route.path);
                }
                return this.$route.path === paths;
            },
            goTo(path) {
                this.$router.push(path);
            },
            handleItemClick(item) {
                this.$emit("handle-item-click", item);
            },
            showLoginButton() {
                return SystemRole.getUserRole() === null && !SystemRole.isPublic();
            },
            toggleLoginSidebar() {
                this.$emit("toggle-login-sidebar");
            },
            toggleMenu(e) {
                this.$refs.menu.toggle(e);
            },
            onTabChange(e) {
                this.activeIndex = e.index;
                if (e.index === 0) {
                    this.$refs.nestedMenu.toggle(e.originalEvent);
                } else {
                    this.$refs.nestedMenu.hide();
                }
            },
        },
        computed: {
            userItems() {
                return [
                    {
                        label: "Ustawienia",
                        to: "/public/user/settings",
                    },
                    {
                        label: "Moje adresy",
                        to: "/public/user/address",
                    },
                    {
                        label: "Moje zgłoszenia",
                        to: "/public/user/reports",
                    },
                    {
                        label: "Regulamin",
                        url: "/public/regulamin_notyfikacje.pdf",
                        target: "_blank",
                    },
                    {
                        label: "Wyloguj",
                        command: () => {
                            if (this.onLogout) {
                                this.onLogout();
                            }
                        },
                    },
                ];
            },
        },
    };

</script>
<style lang="less">
    @import "../assets/less/tabmenu.less";
</style>
<style scoped lang="less">
    @import "../../assets/theme/variable.less";

    .menu-field {
        height: 4.5em;
        position: fixed;
        border-top: 4px solid #E8E8E8;
        border-bottom: none;
        bottom: 0;
        .menu-inner-field {
            padding: 0 8px 0 8px;
            display: flex;
            justify-content: center;
            gap: 20vw;
        }
    }

    .mobile-bottom-menu-button {
        &.active {
            color: @color-red-active;
        }
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }

    :deep(.pi) {
        font-size: 1.2em;
    }

    :deep(.button-icon) {
        transform: translateY(15%);
    }

    :deep(.button-inside) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;
    }

    :deep(.button-label) {
        position: fixed;
        transform: translate(0, 120%);
        min-width: max-content;
        max-width: 120px;
        z-index: 10;
        font-size: 0.875rem;
    }

    .submenu {
        left: 50%;
        transform: translateX(-65%);
        position: absolute;
        width: 150px;
        top: 100%;
        background-color: white;
        box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        z-index: 1000;
        margin-top: 5px;
        padding-bottom: 8px;
    }
    .submenu::before {
        content: '';
        position: absolute;
        top: 12px;
        width: 0;
        height: 0;
        box-sizing: border-box;
        border: 10px solid black;
        border-color: transparent transparent white white;
        transform-origin: 0 0;
        box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.4);
        transform: rotate(135deg) translateX(-75%);
    }

    .submenu::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 6px;
        background-color: #0075c2;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    .submenu a {
        display: block;
        padding: 10px;
        text-decoration: none;
        color: black;
        border-radius: 8px;
        transition: background-color 0.3s ease;
    }

    .submenu a:hover {
        background-color: #f0f0f0;
    }

    .menu-item {
        height: 100%;
    }

</style>
